import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=755551dd&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755551dd')) {
      api.createRecord('755551dd', component.options)
    } else {
      api.reload('755551dd', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=755551dd&", function () {
      api.rerender('755551dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4txOZF42RsXAR/JS/videoIframe.vue"
export default component.exports